<template>
  <div class="base-container">
    <div v-if="account" class="header">
      <div class="absolute flex items-center">
        <img
          loading="lazy"
          class="block w-[26px] h-[26px] rounded-full border-[1px] border-solid border-back-2 ml-[12px]"
          :src="userInfo.logo_url"
        />
        <span class="pl-[10px] text-[14px] leading-[20px] font-medium account-name">
          {{ userInfo.account_name }}
        </span>
      </div>
      <div class="title">{{ title }}</div>
      <button class="close" type="button">
        <iconpark-icon name="close" size="18" @click="handleClose"></iconpark-icon>
      </button>
    </div>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>
<script lang="ts" name="BaseContainer" setup>
withDefaults(defineProps<{ title: string; account?: boolean; closeRefresh?: boolean }>(), {
  account: true, // 这个弹窗基本是支付相关的通用弹窗，所以默认展示用户信息
  closeRefresh: false, // 关闭弹窗时是否需要刷新页面
});

const emitter = defineEmits(['cancel']);

const userInfo = useUserInfo();

const handleClose = () => {
  // location.reload()
  emitter('cancel');
};
</script>
<style lang="scss" scoped>
.base-container {
  @apply w-full h-auto rounded-[12px];
  background: var(--subscribe-modal-bg);
  padding: 12px 8px 8px;

  .account-name {
    color: var(--text-0);
  }

  .header {
    @apply relative mb-[12px] text-center;
    .title {
      @apply inline-block  leading-[28px];
      font-weight: 600;
      color: var(--text-0);
      font-size: 16px;
    }

    .close {
      @apply absolute top-[3px] cursor-pointer outline-none p-0 m-0 border-0 w-[18px] h-[18px] rounded-[4px] leading-[1] bg-transparent transition-colors;
      right: 12px;
      color: var(--text-0);
      &:hover {
        color: rgba(61, 65, 100, 1);
        background-color: rgba(0, 0, 0, 0.06);
        text-decoration: none;
      }
    }
  }

  .content {
    // @apply w-full h-[490px] overflow-hidden box-border;
    @apply w-full box-border;
  }
}
</style>
